import React, { useEffect, useState } from "react";
import "./About.css";
import { Modal, TransitionablePortal, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import PublicSlideshow from "../components/layout/Slideshow/PublicSlideshow";
export const emailPreFix = "mailto:";
export const phonePreFix = "tel:";
const About = (props) => {
  const [data, setData] = useState(null);
  const [advocates, setAdvocates] = useState([]);
  const [handleModal, setHandleModal] = useState(false);
  const [moreInfo, setMoreInfo] = useState(null);
  const animation = "scale";
  const duration = 500;
  useEffect(() => {
    if (props.advocateData) {
      setData(props.advocateData);
    }
  }, [props.advocateData]);
  useEffect(() => {
    if (data) {
      let storingObject = Object.keys(data);
      let activeObject = [];
      if (storingObject.length > 0) {
        activeObject = storingObject.map((key, i) => {
          return {
            id: data[key].id,
            name: data[key].name,
            title: data[key].title,
            thumbnailUrl: data[key].thumbnailUrl,
            about: data[key].about,
            phone: data[key].phone,
            email: data[key].email,
            facebook: data[key].facebook,
            instagram: data[key].instagram,
            twitter: data[key].twitter,
            linkedin: data[key].linkedin,
            createdAt: data[key].createdAt,
            order: data[key].order,
          };
        });
        activeObject = activeObject.sort((a, b) => a.order - b.order);
      }
      setAdvocates(activeObject);
    }
  }, [data]);
  let card;
  const moreInfoModal = (id) => {
    const advocatesData = [...advocates];
    const advocate = advocatesData.filter((data) => data.id === id);
    const advocateObj = { ...advocate[0] };

    if (advocateObj.phone) {
      const phone = advocateObj.phone;
      const partOne = phone.slice(0, 3);
      const partTwo = phone.slice(3, 6);
      const partThree = phone.slice(6);
      advocate[0].phone = `(${partOne}) ${partTwo}-${partThree}`;
    }
    setMoreInfo(advocate);
    setHandleModal(true);
  };
  if (advocates.length > 0) {
    card = advocates.map((advocate) => {
      return (
        <>
          <div className="card" key={advocate.id}>
            <div className="card-body">
              <img
                src={advocate.thumbnailUrl}
                alt={advocate.thumbnailUrl}
                className="user-picture shadow-sm rounded-circle"
              />
              <div className="user-content">
                <h5 className="text-capitalize user-name">{advocate.name}</h5>
                <p className=" text-capitalize text-muted small blockquote-footer">
                  {advocate.title}
                </p>
                <p className="small text-muted mb-0 pl0 line-break-4">
                  {advocate.about}
                </p>

                <div className="with-social-logo">
                  {advocate.facebook && (
                    <a
                      href={advocate.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../images/facebook.svg").default}
                        alt="Facebook"
                      />
                    </a>
                  )}
                  {advocate.twitter && (
                    <a
                      href={advocate.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../images/twitter.svg").default}
                        alt="Twitter"
                      />
                    </a>
                  )}
                  {advocate.instagram && (
                    <a
                      href={advocate.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../images/instagram.svg").default}
                        alt="Instagram"
                      />
                    </a>
                  )}
                  {advocate.linkedin && (
                    <a
                      href={advocate.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../images/linkedIn.svg").default}
                        alt="Linked In"
                      />
                    </a>
                  )}
                </div>

                <span
                  className="view-more"
                  onClick={() => moreInfoModal(advocate.id)}
                >
                  View More
                </span>
              </div>
            </div>
          </div>
        </>
      );
    });
  }

  return (
    <>
      <div className="AboutBackground">
        <div className="AboutBannerBar"></div>
        <div className="AboutContainer">
          <h1>About CSA</h1>
          <div className="AboutImageContainer">
            <img
              src={require("../images/csaContact.png").default}
              alt="About CSA"
            />
          </div>
          <p>
            Collegiate Sports Advocate was created to help Student Athletes find
            the RIGHT FIT and we are committed to helping them through the
            entire experience and to see them GRADUATE College. It's about the
            journey and the experience not just signing day! We want our Student
            Athletes to have a successful career. We only hire Advocates that
            have played in College, Coached in College or have been through the
            experience with other Student Athletes. We are all about the
            RELATIONSHIP with the College Coaches and the Student Athletes and
            their families!
          </p>
          <PublicSlideshow />
          <h3>Our Team</h3>
        </div>
        <div className="team-section">{card}</div>

        {moreInfo && (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={handleModal}
            onClose={() => {
              setHandleModal(false);
            }}
          >
            <Modal
              centered
              size="tiny"
              className="centeredModal"
              onClose={() => {
                setHandleModal(false);
              }}
              open={handleModal}
            >
              <Modal.Content scrolling>
                <Button
                  floated="right"
                  icon="close"
                  circular
                  onClick={() => {
                    setHandleModal(false);
                  }}
                />
                <div className="team-section single">
                  <div className="card">
                    <div className="card-body">
                      <img
                        src={moreInfo[0].thumbnailUrl}
                        alt={moreInfo[0].thumbnailUrl}
                        className="user-picture shadow-sm rounded-circle"
                      />
                      <div className="user-content">
                        <h5 className="text-capitalize user-name">
                          {moreInfo[0].name}
                        </h5>
                        <p className=" text-capitalize text-muted small blockquote-footer">
                          {moreInfo[0].title}
                        </p>
                        <div className="with-social-logo">
                          {moreInfo[0].facebook && (
                            <a
                              href={moreInfo[0].facebook}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={require("../images/facebook.svg").default}
                                alt="Facebook"
                              />
                            </a>
                          )}
                          {moreInfo[0].twitter && (
                            <a
                              href={moreInfo[0].twitter}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={require("../images/twitter.svg").default}
                                alt="Twitter"
                              />
                            </a>
                          )}
                          {moreInfo[0].instagram && (
                            <a
                              href={moreInfo[0].instagram}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={require("../images/instagram.svg").default}
                                alt="Instagram"
                              />
                            </a>
                          )}
                          {moreInfo[0].linkedin && (
                            <a
                              href={moreInfo[0].linkedin}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={require("../images/linkedIn.svg").default}
                                alt="Linked In"
                              />
                            </a>
                          )}
                        </div>
                        <p className="small text-muted mb-0 pl0">
                          {moreInfo[0].about}
                        </p>

                        <div className="conect-data">
                          {moreInfo[0].phone && (
                            <div>
                              <p>
                                Cell :
                                <a href={phonePreFix + moreInfo[0].phone}>
                                  {moreInfo[0].phone}
                                </a>
                              </p>
                            </div>
                          )}
                          <div>
                            <p>
                              Email :
                              <a href={emailPreFix + moreInfo[0].email}>
                                {moreInfo[0].email}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    advocateData: state.firestore.ordered.advocates,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
  ])
)(About);
